module.exports = __webpack_public_path__ + "assets/fonts/print-text.02c08b02.svg";